$(document).ready(() => {
  const currentLocale = getCurrentLocale();
  if (!$('.exportPaymentOperationsBtn').length) {
    return null
  };

  const $exportPaymentOperationsBtn = $('.exportPaymentOperationsBtn');
  const forms = document.querySelectorAll(`.modal form`);
  const $exportsSection = $('#operations');
  const $newExportContainer = $('.export-entries');
  const downloadTranslation = {
    'download': {
      'fr': 'Télécharger',
      'en': 'Download',
      'es': 'Descargar',
    },
    'in_progress': {
      'fr': 'En cours de chargement',
      'en': 'Loading',
      'es': 'Cargando',
    },
    'failed': {
      'fr': 'Erreur',
      'en': 'Error',
      'es': 'Error',
    }
  };

  const scrollToTable = () => {
    $('html, body').animate({
      scrollTop: $('.export-entries').offset().top
    }, 1000);
  }

  const displayExportsSection = () => {
    if ($exportsSection.hasClass('d-none')) { $exportsSection.removeClass('d-none') }
  }

  const addNewExportRow = (exportId, exportData) => {
    const new_export_row =
      `<tr id='newExportRow${exportId}'>
        <td class='export-date'>
            ${$exportPaymentOperationsBtn.data('current-date')}
          </td>
          <td class='export-format'>
            <img src='${exportData.format_image_url}' height='30' class='me-2' />
          </td>
          <td class='export-name'>
            -
          </td>
          <td class='export-status'>
            ${exportData.status}
          </td>
          <td class='export-document'>
            <div class='spinner-bar'>
              ${$exportPaymentOperationsBtn.data('spinner-image')}
            </div>
          </td>
        </tr>`;

    $newExportContainer.prepend(new_export_row);
  }

  const submitBtnContent = {
    'fr': 'Générer',
    'en': 'Generate',
    'es': 'Generar',
  }

  const resetForm = (form) => {
    const submitBtn = form.querySelector('input[type=\'submit\']');
    submitBtn.disabled = false;
    submitBtn.value = submitBtnContent[currentLocale];
  }

  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      displayExportsSection();

      fetch(e.currentTarget.action, {
        method: 'POST',
        body: new FormData(e.currentTarget)
      })

      $('.modal.fade.show').modal('hide');
      scrollToTable();
    })
  })

  App.cable.subscriptions.create(
    { channel: 'ExportPaymentOperationsChannel' }, {
      received(data) {
        if (data.generating) {
          addNewExportRow(data.export_id, data);
        } else if (data.success) {
          export_url = data.export_url;
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);

          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-format').html(`<img src='${data.format_image_url}' height='30' class='me-2' />`);
          $newExportRowEl.find('.export-status').html(data.status);
          $newExportRowEl.find('.export-name').html(data.name);

          const $downloadLink = $newExportRowEl.find('.export-document');
          $downloadLink.html(`<a href='${export_url}' target='_blank' rel= 'noopener noreferrer nofollow'>${downloadTranslation['download'][currentLocale]}</a>`);

          forms.forEach(resetForm);
        } else {
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);
          $newExportRowEl.find('.export-document .spinner-bar').remove();
          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-format').html(`<img src='${data.format_image_url}' height='30' class='me-2' />`);
          $newExportRowEl.find('.export-status').html(downloadTranslation['failed'][currentLocale]);
          $newExportRowEl.find('.export-document').html(`<img src='${data.failed_icon_url}' height='30' class='me-2' />`)

          forms.forEach(resetForm);
        }
      }
    }
  );
});
